var map = {
	"./1.png": 6500,
	"./2.png": 2996,
	"./3.png": 2285,
	"./4.png": 7914,
	"./5.png": 9886,
	"./6.png": 644,
	"./7.png": 5973,
	"./backArrow.png": 6843,
	"./kidsbackground.png": 4895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2947;